<template>
    <div class="flex-1 flex flex-col sm:items-center justify-between border-r border-gray-400 cursor-pointer"
        :class="selected ? selected_bg : hover_bg"
        @click="filter"
    >
        <div class="flex flex-row mx-4 xs:mx-6 sm:mx-0 py-2 sm:py-2 sm:mt-5 sm:py-0 sm:flex-col items-center">
            <div class="flex flex-shrink-0 w-8 h-8 md:w-9 md:h-9 border border-gray-600 rounded-full items-center justify-center bg-white">
                <i class="fa text-lg md:text-xl" :class="[icon, text_color]" aria-hidden="true"></i>
            </div>

            <div class="flex items-center mt-0 sm:mt-2 md:mt-0 sm:mb-2 pr-2">
                <h2 class="text-4xl md:text-6xl font-semibold mx-4" :class="text_color">{{ tally }}</h2>

                <p class="text-sm text-gray-600 leading-4">
                    {{ $t(status_text) }}
                </p>
            </div>
        </div>

        <div class="flex w-full border-b-2" :class="border_color"></div>
    </div>
</template>

<script>
export default {
    props: {
        color: {},
        selected: {},
        selected_bg: {},
        hover_bg: {},
        text_color: {},
        border_color: {},
        tally: {},
    },

    computed: {
        status_text() {
            switch (this.color) {
                case 'green':
                    return this.tally === 1
                        ? 'property is on track, looking good.'
                        : 'properties are on track, looking good.';
                case 'yellow':
                    return this.tally === 1
                        ? 'property is in danger of becoming late.'
                        : 'properties are in danger of becoming late.';
                case 'red':
                    return this.tally === 1
                        ? 'property is late, please update immediately.'
                        : 'properties are late, please update immediately.';
            }
        },
        icon() {
            switch (this.color) {
                case 'green':
                    return 'fa-check-circle';
                case 'yellow':
                    return 'fa-exclamation-circle';
                case 'red':
                    return 'fa-exclamation-circle';
            }
        },
    },

    methods: {
        filter() {
            this.$emit('filter', this.color);
        },
    },
}
</script>
